import { ReactComponent } from './wallbox-xl.svg';
export const WallboxIconXl = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=wallbox-xl.js.map